import React, { Component } from 'react';

import './Discover.css';

import play from '../assets/play.svg'
import app from '../assets/app.svg'
import producten from '../assets/Logo.png'




class Discover extends Component {

  render() {
    return(
      <section className='discover'>
        <h1>Download de McDonald's App</h1>
        <p>Oeps! We kunnen je McDonald’s App niet vinden. Ga dus naar de App Store of Google Play Store en download de app. Heb je onze app al? Open dan de link op je telefoon.</p>
        <div className='footer__icons-container'>
            <a href='https://play.google.com/store/apps/details?id=com.mcdonalds.mobileapp&hl=nl'>
              <img className='downloads_buttons' src={play} alt="play"/>
            </a>
            <a href='https://itunes.apple.com/nl/app/mcdonalds/id1217507712'>
              <img className='downloads_buttons' src={app} alt="app"/>
            </a>
          </div>
          <div className='producen'>
          <img className='producten' src={producten} alt='producten' />
          </div>
      </section>
    )
  }
}

export default Discover;



// WEBPACK FOOTER //
// ./src/components/Discover.jsx